import { Routes } from '@angular/router';
import { SsoLoginComponent } from './sso-authentication/sso-login/sso-login.component';
import { Dashboard } from './sso-authentication/dashboard/dashboard';
import { authGuard } from './guards/auth.guard';
import { Registration } from './sso-authentication/registration/registration';

export const routes: Routes = [

    {
      path: '',
      component: SsoLoginComponent,
      canActivate: [],
    },
    {
      path: 'dashboard',
      component: Dashboard,
      canActivate: [authGuard]
    },
    {
      path: 'register',
      component: Registration
    }
];
